import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Organizer } from "./types/organizer.type";

@Injectable({
  providedIn: "root",
})
export class OrganizersService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.API_BACKEND}/organizers`;

  getOrganizer(organizerPage: string): Observable<Organizer> {
    return this.http.get<Organizer>(`${this.baseUrl}/${organizerPage}`);
  }
}
